import { AppTreeSide, UniDateRangePicker } from 'components'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import {getRegionList, getEncoderList, getDepartmentList, getPersonList} from '@/api/get-data.js'
import {loadRegionTree} from '@/utils/tree'
import {getBeginAndEndDate} from '@/utils/date'

export default {
  name: 'Camera',
  data () {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 树数据
      treeData: [],
      // 树查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      treeExpandedKeys: [], // 默认展开树节点key
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 表格数据
      tableData: [],
      tableTotalRow: 0,
      // 遮罩层
      loading: false,
      // 表格查询条件
      dates: [], // 查询起始和结束日期
      tableQueryParams: {
        regionId: -1,
        descendantRegionRequired: 1,
        deviceGroup: 0, // 设备种类，0-无，1-视频监控设备，2-语音广播设备，3-测控设备，4-出入口控制设备，5-消防设备，6-网络通信设备，7-服务器，254-其他
        archiveStatuss: [],
        archiveBeginDateTime: 0,
        archiveEndDateTime: 0,
        pageNum: 1,
        pageSize: 10
      },
      // 表格当前行
      tableCurrentRow: {},
      tableCurrentStreamNode: {},
      tableCurrentOwnerPersonPhone: '',
      tableCurrentMaintenancePersonPhone: '',
      tableCurrrentPreviewPictureUrls: [],
      // 表格选中记录数组
      tableSelectedIds: [],
      // 活动页面索引
      activeTabName: '0',
      // 记录编辑
      modalOpen: false,
      modalActiveTabName: '0',
      expiryDate: '',
      installationDate: '',
      modalForm: {
        id: undefined,
        // 接入信息
        name: undefined,
        comminterfaceKind: 0,
        ip: undefined,
        port: undefined,
        userName: undefined,
        password: undefined,
        secrecy: 0,
        registerWay: 0,
        safetyWay: 0,
        // 设备信息
        assetNum: undefined,
        resourceSubType: 0,
        manufactor: undefined,
        brand: undefined,
        model: undefined,
        spec: undefined,
        expiryDate: undefined,
        // 建设信息
        installationPlace: undefined,
        installationDate: undefined,
        ownerDepartmentId: undefined,
        ownerPersonId: undefined,
        civilCode: undefined,
        longitude: undefined,
        latitude: undefined,
        altitude: undefined,
        roomType: 0,
        positionType: 0,
        projectId: undefined,
        // 维保信息
        maintenanceDepartmentId: undefined,
        maintenancePersonId: undefined,
        // 应用信息
        block: undefined,
        useType: 0,
        // 其他
        expandInfo: undefined,
        pictureUrl: undefined,
        regionId: undefined,
        deviceGroup: 0, // 设备种类，0-无，1-视频监控设备，2-语音广播设备，3-测控设备，4-出入口控制设备，5-消防设备，6-网络通信设备，7-服务器，254-其他
        remark: undefined
      },
      // Modal文件上传
      modalUpload: {
        // 上传的地址
        url: '/api/file/upload'
      },
      // 表单校验
      formRules: {
        name: [
          {required: true, message: '名称不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  components: {
    AppTreeSide,
    UniDateRangePicker
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  mounted () {
    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取监控设备列表
      getEncoderList(() => {
        // 获取部门列表
        getDepartmentList(() => {
          // 获人员列表
          getPersonList(() => {
            // 设置查询起始日期和截止日期
            this.dates = getBeginAndEndDate(new Date(), -3600 * 24 * 365)
            // 获取区域列表
            this.getRegionList2()
            // 上传url增加访问令牌参数
            this.modalUpload.url += '?accessToken=' + this.$store.getters.userToken
          })
        })
      })
    })
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    // 查询区域列表
    getRegionList2() {
      this.loading = true
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.loading = false
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        this.$nextTick(() => {
          if (this.treeData.length) {
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点为当前节点
            this.$refs.tree.setCurrentKey(this.treeData[0].key)
            // 单击当前节点
            this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
          }
        })
      })
    },
    // 查询辅助监控设备列表
    getCameraList() {
      this.tableQueryParams.archiveBeginDateTime = this.dates[0].getTime()
      this.tableQueryParams.archiveEndDateTime = this.dates[1].getTime()
      this.loading = true
      this.$http(this.$api.auxMonitoringDeviceList, this.tableQueryParams).then(
        res => {
          this.loading = false
          if (res.code === 200) {
            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow
            if (res.data.length) {
              this.$refs.table.setCurrentRow(res.data[0]) // 选中首行
            }
          }
        }
      )
    },
    // 查询当前视频节点
    getCurrentStreamNode() {
      if (!this.tableCurrentRow || !this.tableCurrentRow.id) {
        return
      }

      this.$http(this.$api.streamNodeList, {
        regionId: 0,
        auxMonitoringDeviceId: this.tableCurrentRow.id,
        encoderStateRequired: 1, // 要求返回监控设备状态
        pageNum: 1,
        pageSize: 100
      }).then(
        res => {
          if (res.code === 200 && res.data.length > 0) {
            this.tableCurrentStreamNode = res.data[0]
          } else {
            this.tableCurrentStreamNode = {
              encoderId: 0,
              encoderVideoInputNum: '0',
              streamOpenMode: 0,
              alarmState: 2,
              eventTypeSet: 0,
              encoderAlarmState: 2,
              encoderEventTypeSet: 0,
              resourceCode: ''
            }
          }
        }
      )
    },
    // 是否已过保
    dateExpired(expiryDate) {
      if (!expiryDate) {
        return false
      }
      if (expiryDate < Number(new Date().Format('yyyyMMdd'))) {
        return true
      } else {
        return false
      }
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (this.tableQueryParams.regionId !== obj.id) {
        this.tableQueryParams.regionId = obj.id
        this.tableQueryParams.pageNum = 1
        this.getCameraList()
      }
    },
    // 表格选中记录改变
    handleTableSelectionChange(selection) {
      this.tableSelectedIds = selection.map(item => item.id)
    },
    // 表格当前记录改变
    handleTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }

      this.tableCurrentRow = currentRow
      // 获取业主单位联系电话
      this.tableCurrentOwnerPersonPhone = ''
      let person = this.getRecordById(this.tableCurrentRow.ownerPersonId, this.$globalData.persons)
      if (person != null) {
        this.tableCurrentOwnerPersonPhone = person.phone
      }
      // 获取维保联系电话
      this.tableCurrentMaintenancePersonPhone = ''
      person = this.getRecordById(this.tableCurrentRow.maintenancePersonId, this.$globalData.persons)
      if (person != null) {
        this.tableCurrentMaintenancePersonPhone = person.phone
      }
      this.tableCurrrentPreviewPictureUrls = []
      this.tableCurrrentPreviewPictureUrls.push(this.tableCurrentRow.pictureUrl)
      // 查询当前视频节点
      this.getCurrentStreamNode()
    },
    // 查询按钮操作
    handleFormQuery() {
      this.tableQueryParams.pageNum = 1
      this.getCameraList()
    },
    // 重置按钮操作
    resetQueryForm() {
      this.tableQueryParams.regionId = 0
      this.tableQueryParams.archiveBeginDateTime = 0
      this.tableQueryParams.archiveEndDateTime = 0
      this.tableQueryParams.archiveStatuss = []
      this.tableQueryParams.pageNum = 1
      this.dates = getBeginAndEndDate(new Date(), -3600 * 24 * 365)
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleCurrentPageChange(val) {
      this.tableQueryParams.pageNum = val
      this.getCameraList()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.tableQueryParams.pageSize = val
      this.getCameraList()
    },
    // 新增记录
    handleAdd() {
      this.resetmodalForm()
      this.modalOpen = true
    },
    // 修改记录
    handleModify(data) {
      this.modalForm.id = data.id
      // 接入信息
      this.modalForm.name = data.name
      this.modalForm.commInterfaceKind = data.commInterfaceKind
      this.modalForm.ip = data.ip
      this.modalForm.port = data.port
      this.modalForm.userName = data.userName
      this.modalForm.password = data.password
      this.modalForm.secrecy = data.secrecy
      this.modalForm.registerWay = data.registerWay
      this.modalForm.safetyWay = data.safetyWay
      // 设备信息
      this.modalForm.assetNum = data.assetNum
      this.modalForm.deviceGroup = data.deviceGroup
      this.modalForm.resourceSubType = data.resourceSubType
      this.modalForm.manufactor = data.manufactor
      this.modalForm.brand = data.brand
      this.modalForm.model = data.model
      this.modalForm.spec = data.spec
      this.expiryDate = this.dateFromInt(data.expiryDate)
      this.modalForm.expiryDate = data.expiryDate
      // 建设信息
      this.modalForm.installationPlace = data.installationPlace
      this.installationDate = this.dateFromInt(data.installationDate)
      this.modalForm.installationDate = data.installationDate
      this.modalForm.ownerDepartmentId = data.ownerDepartmentId
      this.modalForm.ownerPersonId = data.ownerPersonId
      this.modalForm.civilCode = data.civilCode
      this.modalForm.longitude = data.longitude
      this.modalForm.latitude = data.latitude
      this.modalForm.altitude = data.altitude
      this.modalForm.roomType = data.roomType
      this.modalForm.positionType = data.positionType
      this.modalForm.projectId = data.projectId
      // 维保信息
      this.modalForm.maintenanceDepartmentId = data.maintenanceDepartmentId
      this.modalForm.maintenancePersonId = data.maintenancePersonId
      // 应用信息
      this.modalForm.block = data.block
      this.modalForm.useType = data.useType
      // 其他
      this.modalForm.expandInfo = data.expandInfo
      this.modalForm.pictureUrl = data.pictureUrl
      this.modalForm.regionId = data.regionId
      this.modalForm.remark = data.remark

      this.modalOpen = true
    },
    // 重置表单
    resetmodalForm() {
      this.expiryDate = ''
      this.installationDate = ''
      this.modalActiveTabName = '0'
      this.modalForm = {
        id: undefined,
        // 接入信息
        name: undefined,
        commInterfaceKind: 0,
        ip: undefined,
        port: undefined,
        userName: undefined,
        password: undefined,
        secrecy: 0,
        registerWay: 0,
        safetyWay: 0,
        // 设备信息
        assetNum: undefined,
        resourceSubType: 0,
        manufactor: undefined,
        brand: undefined,
        model: undefined,
        spec: undefined,
        expiryDate: undefined,
        // 建设信息
        installationPlace: undefined,
        installationDate: undefined,
        ownerDepartmentId: undefined,
        ownerPersonId: undefined,
        civilCode: undefined,
        longitude: undefined,
        latitude: undefined,
        altitude: undefined,
        roomType: 0,
        positionType: 0,
        projectId: undefined,
        // 维保信息
        maintenanceDepartmentId: undefined,
        maintenancePersonId: undefined,
        // 应用信息
        block: undefined,
        useType: 0,
        // 其他
        expandInfo: undefined,
        pictureUrl: undefined,
        regionId: undefined,
        deviceGroup: 0, // 设备种类，0-无，1-视频监控设备，2-语音广播设备，3-测控设备，4-出入口控制设备，5-消防设备，6-网络通信设备，7-服务器，254-其他
        remark: undefined
      }
    },
    // 提交新增或修改记录
    handleModalSubmit() {
      this.$refs.modalForm.validate((valid) => {
        if (!valid) {
          return
        }

        this.modalOpen = false
        this.modalForm.expiryDate = this.intFromDate(this.expiryDate)
        this.modalForm.installationDate = this.intFromDate(this.installationDate)
        this.modalForm.regionId = this.tableQueryParams.regionId
        this.$http(this.modalForm.id === undefined ? this.$api.addAuxMonitoringDevice : this.$api.updateAuxMonitoringDevice, this.modalForm).then(res => {
          this.resetmodalForm()
          this.getCameraList()
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        })
      })
    },
    // 取消提交记录
    handleModalCancel() {
      this.resetmodalForm()
      this.modalOpen = false
    },
    // 上传Modal图片文件前
    handleModalBeforeUpload (file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$message.warning('请检查上传文件是否是图片')
        return false
      }
    },
    // 上传Modal图片成功后
    handleModalUploadSuccess (res, file, fileList) {
      if (res.code === 200) {
        this.$message.success('上传成功')
        this.modalForm.pictureUrl = res.data.url
      }
    },
    // 删除记录
    handleDelete(row) {
      if (row && row.id) {
        this.$messagebox.confirm('您确定删除当前选中记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http(this.$api.deleteAuxMonitoringDevice, {
            id: row.id
          }).then(
            res => {
              if (res.code === 200) {
                this.tableQueryParams.pageNum = 1
                this.getCameraList()
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              }
            }
          )
        })
      } else if (this.tableSelectedIds.length > 0) {
        this.$messagebox.confirm('您确定删除选中的' + this.tableSelectedIds.length + '条记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http(this.$api.deleteAuxMonitoringDevice, {
            ids: this.tableSelectedIds
          }).then(res => {
            if (res.code === 200) {
              this.tableQueryParams.pageNum = 1
              this.getCameraList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
        })
      }
    },
    // 清空记录
    handleClear() {
      this.$messagebox.confirm('您确定删除全部记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http(this.$api.deleteAuxMonitoringDevice, {
          id: 0
        }).then(
          res => {
            if (res.code === 200) {
              this.tableQueryParams.pageNum = 1
              this.getCameraList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          }
        )
      })
    },
    // 导入按钮操作
    handleImport() {
    },
    // 视频节点同步下拉菜单操作
    handleImportFromStreamNode(command) {
      let commandText = '完全同步'
      if (command === '1') {
        commandText = '同步新增'
      } else if (command === '2') {
        commandText = '同步修改'
      }
      this.$messagebox.confirm('您确定' + commandText + '视频节点记录(存在数据丢失风险，请慎重操作)吗? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        let params = {synchMethod: Number(command)}
        this.$http(this.$api.synchAuxMonitoringDeviceFromStreamNode, params).then(
          res => {
            this.loading = false
            if (res.code === 200) {
              this.getCameraList()
            }
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/assets/camera/Camera.js